{
  "familyId": "MET-OPP-RECHT",
  "questions": [
    {
      "id": "MET-OPP-RECHT-001",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een tegelzetter legt tegels in een rechthoek van 8 cm lang en 5 cm breed. Wat is de oppervlakte?",
      "options": ["40 cm²", "26 cm²", "13 cm²", "80 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "geo", "data": { "width": 8, "height": 5, "showGrid": true, "unit": "cm" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte rechthoek", "content": "Oppervlakte = lengte × breedte. Dus: 8 × 5 = 40 cm². Het antwoord is in cm² (vierkante centimeter).", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De tegelzetter berekent: oppervlakte = lengte × breedte = 8 × 5 = 40 cm². Vergeet niet het ² symbool bij cm²!",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "Invullen: 8 × 5", "Uitkomst: 40 cm²"],
        "distractorExplanations": {
          "0": "Goed! Oppervlakte = 8 × 5 = 40 cm².",
          "1": "Je dacht waarschijnlijk dat je de omtrek moest berekenen. Maar 8 + 5 + 8 + 5 = 26 cm is de omtrek, niet de oppervlakte. Onthoud: oppervlakte = lengte × breedte (vermenigvuldigen).",
          "2": "Je dacht waarschijnlijk dat je lengte + breedte doet. Maar 8 + 5 = 13 is optellen. Voor oppervlakte moet je vermenigvuldigen: 8 × 5 = 40. Onthoud: oppervlakte = vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat je nog een keer ×2 doet. Maar 8 × 5 × 2 = 80 is te veel. Oppervlakte = lengte × breedte = 8 × 5 = 40. Onthoud: vermenigvuldig alleen lengte × breedte."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-002",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een tuinarchitect ontwerpt een tuin van 12 meter lang en 7 meter breed. Hoeveel vierkante meter is de tuin?",
      "options": ["38 m²", "19 m²", "84 m²", "144 m²"],
      "correctAnswer": 2,
      "stimulusAids": [{ "type": "geo", "data": { "width": 12, "height": 7, "showGrid": true, "unit": "m" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte rechthoek", "content": "Oppervlakte = lengte × breedte = 12 × 7 = 84 m². De eenheid is m² omdat je meters × meters doet.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_garden",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De tuinarchitect berekent: oppervlakte = lengte × breedte = 12 × 7 = 84 m². Omdat je meters × meters doet, is de eenheid m² (vierkante meter).",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "Invullen: 12 × 7", "Uitkomst: 84 m²"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de omtrek moest berekenen. Maar 12 + 7 + 12 + 7 = 38 m is de omtrek. Onthoud: oppervlakte = lengte x breedte = 12 x 7 = 84 m2.",
          "1": "Je dacht waarschijnlijk dat je lengte + breedte doet. Maar 12 + 7 = 19 is optellen. Onthoud: oppervlakte = vermenigvuldigen: 12 x 7 = 84 m2.",
          "2": "Goed! 12 x 7 = 84 m2.",
          "3": "Je dacht waarschijnlijk dat je 12 x 12 doet. Maar gebruik de breedte (7), niet de lengte twee keer. Onthoud: oppervlakte = lengte x breedte = 12 x 7 = 84 m2."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-003",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een timmerman maakt een plank. De oppervlakte is 36 cm² en de lengte is 9 cm. Wat is de breedte?",
      "options": ["3 cm", "4 cm", "6 cm", "18 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{ "type": "geo", "data": { "width": 9, "height": 4, "showGrid": true, "unit": "cm" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Breedte berekenen", "content": "Oppervlakte = lengte × breedte. Dus: breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_reverse",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De timmerman draait de formule om: breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm. Controleer: 9 × 4 = 36 cm² ✓.",
        "solutionSteps": ["Formule omdraaien: breedte = oppervlakte ÷ lengte", "Invullen: 36 ÷ 9", "Uitkomst: 4 cm", "Controle: 9 × 4 = 36 cm² ✓"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 36 ÷ 12 moest rekenen (= 3). Maar je deelt door de lengte (9), niet door 12. Breedte = 36 ÷ 9 = 4 cm. Onthoud: deel de oppervlakte door de gegeven lengte.",
          "1": "Goed! 36 ÷ 9 = 4 cm. Controleer: 9 × 4 = 36 cm² ✓.",
          "2": "Je dacht waarschijnlijk dat 6 × 9 = 36. Maar 6 × 9 = 54, niet 36. De breedte is 36 ÷ 9 = 4 cm. Onthoud: controleer altijd je antwoord door terug te vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat je 36 ÷ 2 = 18 doet. Maar je moet delen door de lengte (9), niet door 2. Breedte = oppervlakte ÷ lengte = 36 ÷ 9 = 4 cm."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-004",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een sportveldbeheerder meet een voetbalveld: 100 meter lang en 65 meter breed. Wat is de oppervlakte?",
      "options": ["330 m²", "165 m²", "10.000 m²", "6.500 m²"],
      "correctAnswer": 3,
      "stimulusAids": [{ "type": "geo", "data": { "width": 100, "height": 65, "showGrid": false, "unit": "m" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlakte groot vlak", "content": "Oppervlakte = 100 × 65 = 6.500 m². Handig: 100 × 65 = 100 × 60 + 100 × 5 = 6.000 + 500 = 6.500.", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_large",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De sportveldbeheerder berekent: oppervlakte = 100 × 65 = 6.500 m². Handig: splits 65 in 60 + 5. Dan: 100 × 60 = 6.000 en 100 × 5 = 500. Totaal: 6.500 m².",
        "solutionSteps": ["Formule: oppervlakte = lengte × breedte", "100 × 65 = ?", "Splits: 100 × 60 = 6.000 en 100 × 5 = 500", "Totaal: 6.000 + 500 = 6.500 m²"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de omtrek moest berekenen. Maar 100 + 65 + 100 + 65 = 330 m is de omtrek. Onthoud: oppervlakte = lengte x breedte = 100 x 65 = 6.500 m2.",
          "1": "Je dacht waarschijnlijk dat je lengte + breedte doet. Maar 100 + 65 = 165 is optellen. Onthoud: oppervlakte = vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je 100 x 100 doet. Maar gebruik de breedte (65), niet de lengte twee keer. Onthoud: 100 x 65 = 6.500 m2.",
          "3": "Goed! 100 x 65 = 6.500 m2."
        }
      }
    },
    {
      "id": "MET-OPP-RECHT-005",
      "familyId": "MET-OPP-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een schilder moet de grootste muur verven. Welke rechthoek heeft de grootste oppervlakte?",
      "options": ["15 cm lang en 6 cm breed", "20 cm lang en 4 cm breed", "10 cm lang en 8 cm breed", "25 cm lang en 3 cm breed"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Oppervlaktes vergelijken", "content": "Bereken elke oppervlakte: 15×6=90, 20×4=80, 10×8=80, 25×3=75. De grootste is 90 cm².", "icon": "lightbulb" } }],
      "conceptId": "area_rectangle_compare",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De schilder berekent elke oppervlakte: 15 × 6 = 90 cm², 20 × 4 = 80 cm², 10 × 8 = 80 cm², 25 × 3 = 75 cm². De grootste oppervlakte is 90 cm².",
        "solutionSteps": ["Bereken alle oppervlaktes:", "15 × 6 = 90 cm²", "20 × 4 = 80 cm²", "10 × 8 = 80 cm²", "25 × 3 = 75 cm²", "Grootste: 90 cm²"],
        "distractorExplanations": {
          "0": "Goed! 15 × 6 = 90 cm² is de grootste oppervlakte.",
          "1": "Je dacht waarschijnlijk dat de langste rechthoek de grootste oppervlakte heeft. Maar 20 × 4 = 80 cm², terwijl 15 × 6 = 90 cm². Onthoud: bereken altijd de oppervlakte, kijk niet alleen naar de lengte.",
          "2": "Je dacht waarschijnlijk dat 10 × 8 = 80 cm² de grootste is. Maar 15 × 6 = 90 cm² is groter. Onthoud: bereken alle oppervlaktes en vergelijk.",
          "3": "Je dacht waarschijnlijk dat de langste rechthoek wint. Maar 25 × 3 = 75 cm² is juist de kleinste! Onthoud: een lange, smalle rechthoek kan kleiner zijn dan een kortere, bredere."
        }
      }
    }
  ]
}